module.exports = __webpack_public_path__ + "assets/media/swan2.3d39a2d5.mp4";